import React, { useEffect, useState } from 'react';
import { FormikErrors } from 'formik';
import { AuthMarketing, Button, FieldWrapper, FormError, LayoutSplit } from 'components';
import { Identity } from 'components/Input';
import { ICreateIdentity } from 'types';
import { AuthContainer, AuthContent, AuthContentInner, AuthFieldset } from '../Auth/styles';

interface IAccountRecoveryProps {
  authHeader: JSX.Element;
  onSubmit: () => void;
  errors: FormikErrors<ICreateIdentity>;
  validateField: (field: 'identity') => boolean;
  isLoading: boolean;
  setFieldValue: (fieldName: string, value: any) => void;
  isValid: boolean;
  dirty: boolean;
  errorMessages: string[];
  handleBlur: (e: Event) => void;
}

const AccountRecoveryAddIdentity = ({ authHeader, onSubmit, errors, validateField, isLoading, errorMessages, isValid, dirty, handleBlur, setFieldValue }: IAccountRecoveryProps) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (errorMessages && errorMessages.length > 0) {
      setShowError(true);
    }
  }, [errorMessages]);

  return (
    <LayoutSplit
      left={
        <AuthContainer>
          <AuthContent data-cy="account-recovery-add-identity-page-1">
            <AuthContentInner>
              {authHeader}
              <form onSubmit={onSubmit}>
                <AuthFieldset>
                  <FieldWrapper data-cy="identity-field" hasError={!isValid} label="Mobile Number" message={validateField('identity') ? errors.identity : ''}>
                    <Identity
                      disabled={isLoading}
                      id="identity"
                      onAccept={(val: string) => {
                        setShowError(false);
                        setFieldValue('identity', val);
                      }}
                      onBlur={handleBlur}
                      placeholder="Mobile Number"
                      type="text"
                      inputMode="numeric"
                      phoneOnly
                    />
                  </FieldWrapper>
                </AuthFieldset>

                {errorMessages &&
                  showError &&
                  errorMessages.map((error: string, index: number) => (
                    <FormError data-cy="form-error" key={`error-message-${index}`}>
                      {error}
                    </FormError>
                  ))}

                <Button data-cy="submit-button" type="submit" label="Continue" disabled={isLoading || !(isValid && dirty)} isProcessing={isLoading} />
              </form>
            </AuthContentInner>
          </AuthContent>
        </AuthContainer>
      }
      right={<AuthMarketing />}
    />
  );
};

export default AccountRecoveryAddIdentity;
